import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {LogementService} from '../../services/logement.service';
import {Router} from "@angular/router";
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import {UserService} from "../../services/user.service";
import {Observable} from "rxjs";
import {Logement} from "../../models/logement";

@Component({
    selector: 'app-cover',
    templateUrl: './cover.component.html',
    styleUrls: ['./cover.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CoverComponent implements OnInit, AfterViewInit {

  @Input()
  title: string = null;

  @Input()
  subtitle: string = null;

  @Input()
  image: string = null;

  @Input()
  shadow = true;

  @Input()
  progress: number = null;

  @ViewChild('contentWrapper') actionsWrapper: ElementRef;

  hasContent = false;

  logementCourantId: number = null;

  public logementCourant$: Observable<Logement>;

  faEdit = faEdit;

  constructor(public logementService: LogementService, public router: Router, public userService: UserService) {

  }

  ngOnInit() {
    this.logementCourant$ = this.logementService.logementCourant;
    this.logementCourantId = this.logementService.getLogementCourantId();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.hasContent = Array.from(this.actionsWrapper.nativeElement.childNodes).filter((el: Node) => el.nodeName != '#comment').length > 0;
    });
  }

}
